import { useState } from 'react';
import Filters from './components/Filters';
import CardGrid from './components/CardGrid';
import { AppParams } from './types/types';

interface AppProps {
	params: AppParams;
}

const App = ({ params }: AppProps) => {
	const { baseUrl, title, posttype, categories, paginationActive, newTab, keyFacts, count } = params;
	const [theCategory, setTheCategory] = useState<string | null>(null);

	const onCategoryChange = (newCategory: string | null) => {
		setTheCategory(newCategory);
	};

	return (
		<div className="wicotec-blocks__inner dynamic-news__inner">
			{title && (
				<div className="dynamic-news__header">
					<h2 className="dynamic-news__title">{title}</h2>
				</div>
			)}
			<Filters categories={categories} categoryChange={onCategoryChange} />
			<CardGrid baseUrl={baseUrl} posttype={posttype} count={count} newTab={newTab} paginationActive={paginationActive} selectedCategory={theCategory} keyFacts={keyFacts} />
		</div>
	);
};

export default App;
